const autoNgTemplateLoaderTemplate1 = require('./porAccessManagement.html');

angular.module('portainer.app').component('porAccessManagement', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'porAccessManagementController',
  controllerAs: 'ctrl',
  bindings: {
    accessControlledEntity: '<',
    inheritFrom: '<',
    entityType: '@',
    updateAccess: '<',
    actionInProgress: '<',
  },
});
